import { render, staticRenderFns } from "./AnalystItem.vue?vue&type=template&id=56ac126d"
import script from "./AnalystItem.vue?vue&type=script&lang=js"
export * from "./AnalystItem.vue?vue&type=script&lang=js"
import style0 from "./AnalystItem.vue?vue&type=style&index=0&id=56ac126d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports